export default "__VITE_ASSET__CT7I$qYo__"